import React from "react";

export default function LoginLoaderButton() {
  return (
    <a>
      <i className="fa-solid fa-spinner fa-spin"> </i> &nbsp; &nbsp; Loading
    </a>
  );
}
